import { all, takeLatest, call, put } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { questionarioSatisfacaoActions } from "./reducer";
import { apiCall } from "../../utils/apiCall";
import { getQuestionarioSatisfacaoCodigo } from "../../utils/questionarioSatisfacaoRegras";
import { PesquisaQuestionarioSatisfacao } from "../entrega/types/questionario_satisfacao";

function* questionarioSatisfacaoRequestWorker() {
  try {
    const codigo = getQuestionarioSatisfacaoCodigo();

    if (!codigo) {
      yield put(questionarioSatisfacaoActions.questionarioSatisfacaoRequestSuccess(null));
      return;
    }

    const res: AxiosResponse<PesquisaQuestionarioSatisfacao | null> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/questionario-satisfacao?codigo=${encodeURIComponent(codigo)}`,
      method: "GET",
    });

    yield put(questionarioSatisfacaoActions.questionarioSatisfacaoRequestSuccess(res.data ?? null));
  } catch (error) {
    console.log("error questionarioSatisfacaoRequestWorker", error);
  }
}

export function* questionarioSatisfacaoSaga() {
  yield all([
    takeLatest(
      questionarioSatisfacaoActions.questionarioSatisfacaoRequest.type,
      questionarioSatisfacaoRequestWorker
    ),
  ]);
}
